export enum FontSizes {
    small = '14px',
    medium = '16px',
    large = '18px',
}
